<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Roles
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" to="roles/add">
              <v-icon medium>add_circle_outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="headers"
            :items="items"
            :rows-per-page-items="[10,25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :loading="rolesLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td>
                  <v-chip
                  class="white--text"
                  small
                  v-for="(scope, i) in props.item.scopes.slice(0, 2)" :key="i"
                  color="accent">
                    {{ scopeCollection[scope].Name }}
                  </v-chip>
                  <v-chip
                  v-if="props.item.scopes.length > 2"
                  small
                  >
                    +{{ props.item.scopes.length - 2 }} more
                  </v-chip>
                </td>
                <td class="text-xs-right">
                  <v-tooltip bottom color="accent">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/roles/${props.item.id}/edit`)"
                    >
                      edit
                    </v-icon>
                    <span>Edit Item</span>
                  </v-tooltip>
                  <v-tooltip bottom color="error">
                    <v-icon
                      color="error"
                      slot="activator"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>Delete Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
    v-model="dialog"
    max-width="500"
    >
      <v-card>
        <v-card-title class="headline">Delete role</v-card-title>
        <v-card-text>
          Are you sure to delete this role?
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            :disabled="deleteLoading"
            @click="dialog = false; itemToDelete = {};"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            depressed
            class="white--text"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click.native="deleteItem()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Created', sortable: true, value: 'createdDate'},
        {text: 'Scopes', sortable: true, value: 'scopes'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      items: [],
      dialog: false,
      logsToShow: [],
      itemToDelete: {},
      deleteLoading: false,
      rolesLoading: false,
      pagination: {
        sortBy: 'id'
      }
    }
  },
  created () {
    this.rolesLoading = true
    this.fetchRoles()
  },
  computed: {
    ...mapState({
      scopeCollection: state => state.configurations.authScopes
    })
  },
  methods: {
    fetchRoles () {
      this.axios.get('/roles')
        .then(response => {
          if (response.data) {
            this.items = response.data.map(role => ({
              id: role.id,
              name: role.Name,
              createdDate: role.CreatedDate,
              scopes: role.Scopes
            }))
          }
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.rolesLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/roles/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.items.indexOf(this.itemToDelete)
          this.items.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    }
  }
}
</script>

<style>

</style>
